/**
 * The Cookie Monster.
 * This class is responsible for everything cookie related in the browser.
 * It sets, gets and eats cookies.
 */
class Cookie {
  /**
   * Set cookie.
   *
   * @param {String} cookieName Name of cookie to set.
   * @param {String} cookieValue Value to save in cookie.
   * @param {Integer|Boolean} expiration When cookie should expire (seconds). Defaults to false (session cookie).
   * @returns {void}
   */
  set(cookieName, cookieValue, expiration = false) {
    let expires = '';
    if (expiration) {
      const date = new Date();
      date.setTime(date.getTime() + expiration * 1000);
      expires = ` expires=${date.toGMTString()};`;
    }
    window.document.cookie = `${cookieName}=${cookieValue}; path=/;${expires}`;
  }

  /**
   * Get cookie value by name.
   *
   * @param {String} cookieName Name of cookie to get.
   * @returns {String} Cookie value.
   */
  get(cookieName) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${cookieName}=`);
    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
    return false;
  }

  /**
   * Delete a cookie by name.
   *
   * @param {String} cookieName Name of cookie to delete.
   * @returns {void}
   */
  delete(cookieName) {
    const date = new Date();
    date.setTime(date.getTime() - 1000 * 60 * 60 * 24);
    const expires = date.toGMTString();
    window.document.cookie = `${cookieName}=; path=/; expires=${expires}`;
  }
}

const cookie = new Cookie();

export default cookie;
